export default [
	{
		path: '/transactions',
		name: 'transactions',
		meta: {
			requiresAuth: true,
			section: 'transactions',
		},
		component: () => import('@/views/transactions/Transactions'),
	},
	// {
	// 	path: '/events/create',
	// 	name: 'EventCreate',
	// 	meta: {
	// 		requiresAuth: true,
	// 		section: 'events',
	// 	},
	// 	component: () => import('@/views/events/EventForm'),
	// },
	// {
	// 	path: '/events/:id/update',
	// 	name: 'EventUpdate',
	// 	meta: {
	// 		requiresAuth: true,
	// 		section: 'events',
	// 	},
	// 	component: () => import('@/views/events/EventForm'),
	// },
	// {
	// 	path: '/events/:id/:tab?',
	// 	name: 'EventDetail',
	// 	meta: {
	// 		requiresAuth: true,
	// 		section: 'events',
	// 	},
	// 	component: () => import('@/views/events/EventDetail'),
	// },
]
